export default function (state = [], action={}) {
    switch (action.type) {
        case "BANNERS_REQUESTED":
            return {
                ...state,
                banners: [],
                bannerLoading: true
            };
        case "BANNERS_FAILED":
            return {
                ...state,
                bannerLoading: false
            };
        case "BANNERS_SUCCESS":
            return {
                ...state,
                banners: action.response && action.response.banners || [],
                bannerLoading: false
            };
        case "DELETE_BANNERS_REQUESTED":
            return {
                ...state,
                banners: [],
            };
        default:
            return state;
    }
}